var _symbol, _use;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAiLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 350,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "ai_logo_svg__b",
    viewBox: "0 0 326 350"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai_logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.367 152.706a22.434 22.434 0 0115.865 6.572 22.434 22.434 0 010 31.73 22.434 22.434 0 01-15.865 6.572c-.554 0-1.122 0-1.663-.066a151.324 151.324 0 000-44.742c.541-.04 1.069-.066 1.663-.066z",
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.705 152.771a151.33 151.33 0 010 44.743 22.44 22.44 0 01-20.736-22.371 22.434 22.434 0 0120.736-22.372z",
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.651 158.209a22.439 22.439 0 0013.053 39.305 149.759 149.759 0 01-159.299 126.97A149.766 149.766 0 011.86 175.143a149.762 149.762 0 01297.844-22.372 22.263 22.263 0 00-13.053 5.438zM94.878 219.885l42.526-27.532.33-.382a22.435 22.435 0 0036.593-22.309 22.431 22.431 0 00-9.512-13.326 22.44 22.44 0 00-30.051 5.146l-40.136-25.987-22.596 42.499 22.846 41.891z",
    fill: "#ED6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.582 152.706a22.448 22.448 0 0115.965 6.512 22.425 22.425 0 016.631 15.915 22.434 22.434 0 01-6.618 15.921 22.44 22.44 0 01-15.959 6.525 22.437 22.437 0 01-.019-44.873z",
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.43 192.353l-42.551 27.532-22.847-41.892 22.596-42.498 40.136 25.987a22.431 22.431 0 00-4.527 15.83 22.434 22.434 0 007.497 14.659l-.304.382z",
    fill: "#ED6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.704 197.514a149.759 149.759 0 01-159.299 126.97A149.766 149.766 0 011.86 175.143a149.762 149.762 0 01297.844-22.372",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.15 113.981l34.91 64.013 22.846 41.891 46.511 85.288m33.602-130.03a22.448 22.448 0 01-13.851 20.729 22.444 22.444 0 01-26.608-7.363 22.434 22.434 0 015.556-32.022 22.434 22.434 0 0121.053-2.074 22.445 22.445 0 017.28 4.863 22.445 22.445 0 016.57 15.867v0zm124.686-22.371c.541 0 1.109-.066 1.663-.066a22.434 22.434 0 0115.865 6.572 22.434 22.434 0 010 31.73 22.434 22.434 0 01-15.865 6.572c-.554 0-1.122 0-1.663-.066a22.433 22.433 0 01-20.729-22.371 22.433 22.433 0 0120.729-22.371v0z",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.826 46.762l-47.171 88.733-22.596 42.499-32.758 61.61",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9 103.924l48.754 31.571 40.136 25.987m2.64 30.872l-42.525 27.531-46.366 30.027m126.481-74.769h103.91M169.08 40.585l117.571 117.624m1.321 35.491L170.4 311.324",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M36.568 176.542a151.927 151.927 0 01135.944-151.07 151.883 151.883 0 00-156.81 87.28 151.885 151.885 0 0075.846 202.025 151.877 151.877 0 0078.087 12.464A151.9 151.9 0 0136.568 176.542z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.363 117.32c12.392 0 22.437-10.045 22.437-22.437 0-12.392-10.045-22.437-22.437-22.437-12.392 0-22.437 10.045-22.437 22.437 0 12.392 10.045 22.437 22.437 22.437v0zm127.219-69.502c12.392 0 22.437-10.046 22.437-22.437 0-12.392-10.045-22.438-22.437-22.438-12.392 0-22.437 10.046-22.437 22.438 0 12.391 10.045 22.437 22.437 22.437zM25.363 279.898c12.392 0 22.437-10.045 22.437-22.437 0-12.392-10.045-22.438-22.437-22.438-12.392 0-22.437 10.046-22.437 22.438s10.045 22.437 22.437 22.437v0zm127.219 67.879c12.392 0 22.437-10.045 22.437-22.437 0-12.392-10.045-22.437-22.437-22.437-12.392 0-22.437 10.045-22.437 22.437 0 12.392 10.045 22.437 22.437 22.437z",
    fill: "#F6F6FB",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.367 152.706a22.434 22.434 0 0115.865 6.572 22.434 22.434 0 010 31.73 22.434 22.434 0 01-15.865 6.572c-.554 0-1.122 0-1.663-.066a151.324 151.324 0 000-44.742c.541-.04 1.069-.066 1.663-.066z",
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.705 152.771a151.33 151.33 0 010 44.743 22.44 22.44 0 01-20.736-22.371 22.434 22.434 0 0120.736-22.372z",
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.93 175.143a22.437 22.437 0 0020.774 22.371 149.759 149.759 0 01-159.299 126.97A149.766 149.766 0 011.86 175.143a149.762 149.762 0 01297.844-22.372 22.44 22.44 0 00-20.774 22.372zm-103.911 0a22.429 22.429 0 00-4.202-13.062 22.438 22.438 0 00-36.027-.599l-40.136-25.987-22.596 42.499 22.82 41.891 42.526-27.532.33-.382a22.434 22.434 0 0033.665-4.67 22.434 22.434 0 003.594-12.158h.026z",
    fill: "#ED6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.582 152.706a22.448 22.448 0 0115.965 6.512 22.425 22.425 0 016.631 15.915 22.434 22.434 0 01-6.618 15.921 22.44 22.44 0 01-15.959 6.525 22.437 22.437 0 01-.019-44.873z",
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.43 192.353l-42.551 27.532-22.847-41.892 22.596-42.498 40.136 25.987a22.431 22.431 0 00-4.527 15.83 22.434 22.434 0 007.497 14.659l-.304.382z",
    fill: "#ED6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.704 197.514a149.759 149.759 0 01-159.299 126.97A149.766 149.766 0 011.86 175.143a149.762 149.762 0 01297.844-22.372",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.148 113.981l34.91 64.013 22.846 41.891 46.512 85.288m33.603-130.03a22.448 22.448 0 01-13.851 20.729 22.436 22.436 0 01-30.592-16.352 22.434 22.434 0 019.54-23.033 22.434 22.434 0 0121.053-2.074 22.445 22.445 0 017.28 4.863 22.445 22.445 0 016.57 15.867v0zm124.685-22.371c.541 0 1.109-.066 1.663-.066a22.445 22.445 0 0115.867 6.57 22.445 22.445 0 014.862 24.453 22.433 22.433 0 01-12.143 12.143 22.429 22.429 0 01-8.586 1.708c-.554 0-1.122 0-1.663-.066a22.433 22.433 0 01-20.729-22.371 22.433 22.433 0 0120.729-22.371v0z",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.825 46.762l-47.171 88.733-22.596 42.499-32.758 61.61",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9 103.924l48.754 31.571 40.136 25.987m2.64 30.872l-42.525 27.531-46.366 30.027m126.48-74.769h103.91M169.08 40.585l117.571 117.624m1.32 35.491L170.399 311.324",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.362 117.32c12.392 0 22.437-10.045 22.437-22.437 0-12.392-10.045-22.437-22.437-22.437-12.392 0-22.437 10.045-22.437 22.437 0 12.392 10.045 22.437 22.437 22.437zm127.22-69.502c12.392 0 22.437-10.046 22.437-22.437 0-12.392-10.045-22.438-22.437-22.438-12.392 0-22.437 10.046-22.437 22.438 0 12.391 10.045 22.437 22.437 22.437zm-127.22 232.08c12.392 0 22.437-10.045 22.437-22.437 0-12.392-10.045-22.438-22.437-22.438-12.392 0-22.437 10.046-22.437 22.438s10.045 22.437 22.437 22.437zm127.22 67.879c12.392 0 22.437-10.045 22.437-22.437 0-12.392-10.045-22.437-22.437-22.437-12.392 0-22.437 10.045-22.437 22.437 0 12.392 10.045 22.437 22.437 22.437z",
    fill: "#F6F6FB",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ai_logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h326v350H0z"
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#ai_logo_svg__b"
  })));
}

export default SvgAiLogo;